import { getRewardsTransactionsHistory } from './rewardsTransactionsHistory.service';
import { IReduxRootState } from '../../../../app/reduxRootState.interface';
import { ThunkDispatch, ThunkAction } from 'redux-thunk';
import {
    RewardsTransactionsHistoryAction,
    RewardsTransactionsHistoryActionTypes,
} from './rewardsTransactionsHistoryActionType';
import { ErrorResolution } from '../../../../app/common/errorResolution/errorResolution';
import { IRewardsTransactionsHistoryResponse } from '../../rewardsClub.interface';
import { RewardsBalanceAction } from '../../rewardsBalance/redux/rewardsBalanceActionType';
import { toTwoDigits } from '../RewardsTransactionsHistoryHelper';

export function rewardsTransactionsHistoryActions(
    year: string,
    month: string,
    currency: string,
): ThunkAction<void, IReduxRootState, {}, RewardsBalanceAction> {
    return async (
        dispatch: ThunkDispatch<IReduxRootState, {}, RewardsTransactionsHistoryAction>,
        getState: () => IReduxRootState,
    ) => {
        const data = {
            currency,
            clientId: getState().app.clientConfig.clientId,
            year,
            month: toTwoDigits(month),
        };
        dispatch(request());
        try {
            const rewardsTransactionsHistory = await getRewardsTransactionsHistory(data);
            dispatch(success(rewardsTransactionsHistory));
        } catch (error) {
            dispatch(failure(error));
        }
    };

    function request(): RewardsTransactionsHistoryAction {
        return {
            type: RewardsTransactionsHistoryActionTypes.GET_REWARDS_TRANSACTIONS_HISTORY_REQUEST,
        };
    }

    function success(
        rewardsTransactionsHistoryResponse: IRewardsTransactionsHistoryResponse,
    ): RewardsTransactionsHistoryAction {
        return {
            type: RewardsTransactionsHistoryActionTypes.GET_REWARDS_TRANSACTIONS_HISTORY_SUCCESS,
            rewardsTransactionsHistoryResponse,
        };
    }

    function failure(error: ErrorResolution): RewardsTransactionsHistoryAction {
        return {
            type: RewardsTransactionsHistoryActionTypes.GET_REWARDS_TRANSACTIONS_HISTORY_FAILURE,
            error,
        };
    }
}
